(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mda-announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  const bar = document.currentScript && document.currentScript.previousElementSibling;
  // Find all bars on page (script is inlined per section)
  document.querySelectorAll('.mda-announcement-bar').forEach((el) => {
    const items = el.querySelectorAll('.mda-announcement-bar__item');
    if (items.length < 2) return;
    const interval = parseInt(el.dataset.rotateInterval, 10) || 0;
    if (!interval) return;
    let i = 0;
    setInterval(() => {
      items[i].setAttribute('hidden', '');
      i = (i + 1) % items.length;
      items[i].removeAttribute('hidden');
    }, interval * 1000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mda-article-body"] && !Shopify.designMode) return;
  try {
    
  // Open every article-body link in a new tab (skip in-page anchors).
  document.querySelectorAll('.mda-article-body a[href]').forEach(function (a) {
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) === '#') return;
    a.setAttribute('target', '_blank');
    a.setAttribute('rel', 'noopener noreferrer');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mda-bundle-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.mdaBplanReady === '1') return;
    root.dataset.mdaBplanReady = '1';

    var tabs = root.querySelectorAll('[role="tab"]');
    if (!tabs.length) return;

    function activate(target) {
      tabs.forEach(function (t) {
        var isActive = t === target;
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        t.setAttribute('tabindex', isActive ? '0' : '-1');
        t.classList.toggle('is-active', isActive);
        var panelId = t.getAttribute('aria-controls');
        var panel = panelId && root.querySelector('#' + panelId);
        if (panel) {
          panel.hidden = !isActive;
          panel.classList.toggle('is-active', isActive);
        }
      });
    }

    tabs.forEach(function (tab, idx) {
      tab.addEventListener('click', function () { activate(tab); });
      tab.addEventListener('keydown', function (e) {
        var key = e.key;
        if (key !== 'ArrowRight' && key !== 'ArrowLeft' && key !== 'Home' && key !== 'End') return;
        e.preventDefault();
        var next = idx;
        if (key === 'ArrowRight') next = (idx + 1) % tabs.length;
        if (key === 'ArrowLeft') next = (idx - 1 + tabs.length) % tabs.length;
        if (key === 'Home') next = 0;
        if (key === 'End') next = tabs.length - 1;
        tabs[next].focus();
        activate(tabs[next]);
      });
    });
  }

  document.querySelectorAll('[data-mda-bplan]').forEach(init);

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector('[data-mda-bplan]');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mda-bundle-whats-included"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-mda-bwi-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('.mda-bwi__grid');
    const prev = carousel.querySelector('[data-dir="prev"]');
    const next = carousel.querySelector('[data-dir="next"]');
    if (!track) return;

    const cardSpan = () => {
      const card = track.querySelector('.mda-bwi__card');
      if (!card) return track.clientWidth;
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    };

    const updateButtons = () => {
      const padLeft = parseFloat(getComputedStyle(track).paddingLeft || '0') || 0;
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      if (prev) prev.disabled = track.scrollLeft <= padLeft + 2;
      if (next) next.disabled = track.scrollLeft >= maxScroll - 2;
    };

    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -cardSpan(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: cardSpan(), behavior: 'smooth' }));
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mda-collection-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* "Shop More" load-more: fetch the next page, append its product cards,
     and advance the button to the page after (or remove it). Falls back to
     full-page navigation if the fetch fails. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mda-shop-more]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('href');
    var root = btn.closest('.mda-collgrid');
    var grid = root && root.querySelector('.mda-collgrid__grid');
    if (!url || !grid) { if (url) window.location.href = url; return; }
    btn.setAttribute('aria-busy', 'true');
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('.mda-collgrid__grid');
        if (newGrid) {
          while (newGrid.firstElementChild) grid.appendChild(newGrid.firstElementChild);
        }
        var nextBtn = doc.querySelector('[data-mda-shop-more]');
        if (nextBtn && nextBtn.getAttribute('href')) {
          btn.setAttribute('href', nextBtn.getAttribute('href'));
          btn.removeAttribute('aria-busy');
        } else {
          btn.parentNode.removeChild(btn);
        }
      })
      .catch(function () { window.location.href = url; });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mda-header"]) return;
  try {
    
(function () {
  document.querySelectorAll('.mda-header').forEach((header) => {
    const toggle = header.querySelector('.mda-header__mobile-toggle');
    const drawer = header.querySelector('.mda-header__mobile');
    if (!toggle || !drawer) return;

    const open = () => {
      drawer.removeAttribute('hidden');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    };
    const close = () => {
      drawer.setAttribute('hidden', '');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    };

    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      expanded ? close() : open();
    });

    const closeBtn = drawer.querySelector('.mda-header__mobile-close');
    if (closeBtn) closeBtn.addEventListener('click', close);

    drawer.addEventListener('click', (e) => {
      if (e.target.tagName === 'A') close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') close();
    });

    /* Desktop mega panels — full-width siblings of the nav row. Click the
       nav button to toggle; only one panel open at a time; clicking the
       same trigger again closes. Block-level when open → pushes everything
       below down via document flow. */
    const triggers = header.querySelectorAll('[data-mda-mega-trigger]');
    const panels = header.querySelectorAll('[data-mda-mega-panel]');
    const closeAllMega = (except) => {
      triggers.forEach((t) => {
        if (t !== except) t.setAttribute('aria-expanded', 'false');
      });
      panels.forEach((p) => {
        if (p !== except) p.setAttribute('hidden', '');
      });
    };
    triggers.forEach((btn) => {
      btn.addEventListener('click', () => {
        const handle = btn.dataset.mdaMegaTrigger;
        const panel = header.querySelector(`[data-mda-mega-panel="${handle}"]`);
        if (!panel) return;
        const isOpen = !panel.hasAttribute('hidden');
        closeAllMega(isOpen ? null : panel);
        if (isOpen) {
          btn.setAttribute('aria-expanded', 'false');
          panel.setAttribute('hidden', '');
        } else {
          btn.setAttribute('aria-expanded', 'true');
          panel.removeAttribute('hidden');
        }
      });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAllMega(null);
    });
    document.addEventListener('click', (e) => {
      if (e.target.closest('.mda-header__mega-panel, [data-mda-mega-trigger]')) return;
      closeAllMega(null);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mda-instagram-feed"] && !Shopify.designMode) return;
  try {
    
(function () {
  const grids = document.querySelectorAll('[data-mda-ig-feed]');
  if (!grids.length) return;

  function truncate(str, max) {
    if (!str) return '';
    const clean = str.replace(/\s+/g, ' ').trim();
    return clean.length > max ? clean.slice(0, max - 1) + '…' : clean;
  }

  function escape(str) {
    const div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function buildTile(post, profileUrl) {
    const li = document.createElement('li');
    li.className = 'mda-ig__tile';

    const a = document.createElement('a');
    a.className = 'mda-ig__tile-link';
    a.href = post.permalink || profileUrl || '#';
    a.target = '_blank';
    a.rel = 'noopener';
    const ariaLabel = truncate(post.caption, 120) || 'Instagram post';
    a.setAttribute('aria-label', ariaLabel);

    const img = document.createElement('img');
    img.className = 'mda-ig__tile-img';
    img.src = post.media_url;
    img.alt = ariaLabel;
    img.loading = 'lazy';
    img.decoding = 'async';

    a.appendChild(img);
    li.appendChild(a);
    return li;
  }

  async function hydrate(grid) {
    const endpoint = grid.dataset.mdaIgEndpoint;
    const count = parseInt(grid.dataset.mdaIgCount || '8', 10);
    const profileUrl = grid.dataset.mdaIgProfileUrl || '#';
    if (!endpoint) return;

    const url = endpoint + (endpoint.includes('?') ? '&' : '?') + 'limit=' + count;

    try {
      const ctrl = new AbortController();
      const timeout = setTimeout(() => ctrl.abort(), 5000);
      const res = await fetch(url, { signal: ctrl.signal, mode: 'cors' });
      clearTimeout(timeout);
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const data = await res.json();
      const posts = Array.isArray(data.posts) ? data.posts : [];
      if (!posts.length) return;

      const frag = document.createDocumentFragment();
      posts.slice(0, count).forEach((p) => frag.appendChild(buildTile(p, profileUrl)));
      grid.replaceChildren(frag);
    } catch (err) {
      if (window.console) console.warn('[mda-ig] live feed failed, keeping fallback', err);
    }
  }

  grids.forEach(hydrate);
})();

/* Mobile: first tap reveals the caption (no navigation); tap again opens the post. */
(function () {
  if (!window.matchMedia('(hover: none)').matches) return;
  document.querySelectorAll('.mda-ig__tile').forEach(function (tile) {
    if (!tile.querySelector('.mda-ig__tile-caption')) return;
    var link = tile.querySelector('.mda-ig__tile-link');
    if (!link) return;
    link.addEventListener('click', function (e) {
      if (!tile.classList.contains('is-revealed')) {
        e.preventDefault();
        document.querySelectorAll('.mda-ig__tile.is-revealed').forEach(function (t) { t.classList.remove('is-revealed'); });
        tile.classList.add('is-revealed');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mda-pdp-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.mda-pdp').forEach((root) => {
    const thumbs = root.querySelectorAll('.mda-pdp__thumb');
    const slides = root.querySelectorAll('.mda-pdp__slide');
    function activateMedia(mediaId) {
      if (!mediaId) return;
      const slide = root.querySelector('.mda-pdp__slide[data-media-id="' + mediaId + '"]');
      if (!slide) return;
      slides.forEach(s => s.classList.remove('is-active'));
      thumbs.forEach(t => t.classList.remove('is-active'));
      slide.classList.add('is-active');
      const thumbBtn = root.querySelector('.mda-pdp__thumb button[data-media-id="' + mediaId + '"]');
      if (thumbBtn && thumbBtn.closest('.mda-pdp__thumb')) thumbBtn.closest('.mda-pdp__thumb').classList.add('is-active');
    }
    thumbs.forEach((thumb) => {
      const btn = thumb.querySelector('button');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.dataset.index, 10);
        thumbs.forEach(t => t.classList.remove('is-active'));
        slides.forEach(s => s.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (slides[idx]) slides[idx].classList.add('is-active');
      });
    });

    const dec = root.querySelector('[data-action="dec"]');
    const inc = root.querySelector('[data-action="inc"]');
    const inp = root.querySelector('.mda-pdp__qty-input');
    if (dec && inc && inp) {
      dec.addEventListener('click', () => { inp.value = Math.max(1, parseInt(inp.value || '1', 10) - 1); });
      inc.addEventListener('click', () => { inp.value = Math.max(1, parseInt(inp.value || '1', 10) + 1); });
    }

    /* Variant URL sync — keeps ?variant=ID accurate for share links + analytics */
    const variantData = root.parentElement.querySelector('script[data-mda-pdp-variants]')
      || document.querySelector('script[data-mda-pdp-variants]');
    let variants = [];
    if (variantData) {
      try { variants = JSON.parse(variantData.textContent); } catch (e) { variants = []; }
    }
    const optionInputs = root.querySelectorAll('input[name^="options["]');
    const variantIdHidden = root.querySelector('input[name="id"]');
    function syncVariant() {
      const selected = [];
      const optionGroups = {};
      optionInputs.forEach(i => {
        if (i.checked) optionGroups[i.name] = i.value;
      });
      Object.keys(optionGroups).forEach(k => selected.push(optionGroups[k]));
      if (selected.length === 0) return;
      const match = variants.find(v => v.options.length === selected.length
        && v.options.every((o, idx) => o === selected[idx]));
      if (!match) return;
      if (variantIdHidden) variantIdHidden.value = match.id;
      activateMedia(match.media);
      const url = new URL(window.location);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }
    optionInputs.forEach(i => i.addEventListener('change', syncVariant));
  });

  /* SEO: keep a single H1 on the PDP — the product title. The Recharge
     subscription widget injects extra <h1> nodes ("Great reasons to
     subscribe"); downgrade any non-title H1 to H2 in the rendered DOM.
     Observe briefly to catch late app injection. */
  function mdaSingleH1() {
    const title = document.querySelector('h1.mda-pdp__title');
    if (!title) return;
    document.querySelectorAll('h1').forEach((h) => {
      if (h === title) return;
      const h2 = document.createElement('h2');
      for (const a of h.attributes) h2.setAttribute(a.name, a.value);
      while (h.firstChild) h2.appendChild(h.firstChild);
      h.replaceWith(h2);
    });
  }
  if (document.readyState !== 'loading') mdaSingleH1();
  else document.addEventListener('DOMContentLoaded', mdaSingleH1);
  const mdaH1Obs = new MutationObserver(() => mdaSingleH1());
  mdaH1Obs.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(() => mdaH1Obs.disconnect(), 8000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mda-pdp-quotes"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.mda-pdpq').forEach((root) => {
    const chips = root.querySelectorAll('.mda-pdpq__chip');
    const quotes = root.querySelectorAll('.mda-pdpq__quote');
    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        const idx = parseInt(chip.dataset.index, 10);
        chips.forEach(c => { c.classList.remove('is-active'); c.setAttribute('aria-selected', 'false'); });
        quotes.forEach(q => q.classList.remove('is-active'));
        chip.classList.add('is-active');
        chip.setAttribute('aria-selected', 'true');
        if (quotes[idx]) quotes[idx].classList.add('is-active');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mda-product-categories"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.mda-prodcats').forEach((root) => {
    const tabs = root.querySelectorAll('.mda-prodcats__tab');
    const panels = root.querySelectorAll('.mda-prodcats__panel');
    if (tabs.length < 2) return;

    const activate = (idx) => {
      tabs.forEach((t, i) => {
        const on = i === idx;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach((p, i) => {
        const on = i === idx;
        p.classList.toggle('is-active', on);
        if (on) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => activate(i));
      tab.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          const next = (i + 1) % tabs.length;
          tabs[next].focus();
          activate(next);
        }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          const prev = (i - 1 + tabs.length) % tabs.length;
          tabs[prev].focus();
          activate(prev);
        }
        if (e.key === 'Home') {
          e.preventDefault(); tabs[0].focus(); activate(0);
        }
        if (e.key === 'End') {
          e.preventDefault(); tabs[tabs.length - 1].focus(); activate(tabs.length - 1);
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mda-product-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.mda-pdp').forEach((root) => {
    const dec = root.querySelector('[data-action="dec"]');
    const inc = root.querySelector('[data-action="inc"]');
    const inp = root.querySelector('.mda-pdp__qty-input');
    if (!dec || !inc || !inp) return;
    dec.addEventListener('click', () => { const v = Math.max(1, parseInt(inp.value || '1', 10) - 1); inp.value = v; });
    inc.addEventListener('click', () => { const v = Math.max(1, parseInt(inp.value || '1', 10) + 1); inp.value = v; });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mda-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Touch only: tap a review tile to reveal its overlay, tap again to hide.
     Desktop uses :hover (CSS). */
  if (!window.matchMedia('(hover: none)').matches) return;
  document.querySelectorAll('.mda-reviews__tiles').forEach((grid) => {
    grid.querySelectorAll('.mda-reviews__tile').forEach((tile) => {
      tile.addEventListener('click', () => {
        var wasOpen = tile.classList.contains('is-revealed');
        grid.querySelectorAll('.mda-reviews__tile.is-revealed').forEach((t) => t.classList.remove('is-revealed'));
        if (!wasOpen) tile.classList.add('is-revealed');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mda-samplepack-beforeafter"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-mda-ba-track]').forEach(function (track) {
  var slides = track.querySelectorAll('[data-mda-ba-slide]');
  if (slides.length < 2) return;
  var index = 0;
  function go(next) {
    index = (next + slides.length) % slides.length;
    track.style.transform = 'translateX(' + (index * -100) + '%)';
    slides.forEach(function (s, i) {
      if (i === index) { s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden', 'true'); }
    });
  }
  track.addEventListener('click', function (e) {
    if (e.target.closest('[data-mda-ba-next]')) { go(index + 1); }
    if (e.target.closest('[data-mda-ba-prev]')) { go(index - 1); }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mda-samplepack-hero-a"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.mda-sphero__code--copy').forEach(function (el) {
  el.addEventListener('click', function () {
    var code = el.getAttribute('data-mda-copy');
    if (!code || !navigator.clipboard) return;
    navigator.clipboard.writeText(code).then(function () {
      el.classList.add('is-copied');
      setTimeout(function () { el.classList.remove('is-copied'); }, 2000);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mda-samplepack-hero-b"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.mda-spherob__code--copy').forEach(function (el) {
  el.addEventListener('click', function () {
    var code = el.getAttribute('data-mda-copy');
    if (!code || !navigator.clipboard) return;
    navigator.clipboard.writeText(code).then(function () {
      el.classList.add('is-copied');
      setTimeout(function () { el.classList.remove('is-copied'); }, 2000);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mda-samplepack-offer"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.mda-spoffer__code--copy').forEach(function (el) {
  el.addEventListener('click', function () {
    var code = el.getAttribute('data-mda-copy');
    if (!code || !navigator.clipboard) return;
    navigator.clipboard.writeText(code).then(function () {
      el.classList.add('is-copied');
      setTimeout(function () { el.classList.remove('is-copied'); }, 2000);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mda-samplepack-progress"] && !Shopify.designMode) return;
  try {
    
(function () {
  function broadcast() { document.dispatchEvent(new CustomEvent('mda:cart:updated')); }
  function cartThen(fn) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(fn).catch(function () {});
  }

  // --- GLOBAL: header cart count follows any cart update ---
  document.addEventListener('mda:cart:updated', function () {
    cartThen(function (cart) {
      var el = document.querySelector('.mda-header__cart-count');
      if (el) el.textContent = cart.item_count;
    });
  });

  // --- GLOBAL: catch every cart mutation (add/change/update/clear) from ANY
  //     source (our buttons, Dawn cart drawer/page, apps) and rebroadcast ---
  if (!window.__mdaCartFetchPatched) {
    window.__mdaCartFetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = '';
      try { url = String((arguments[0] && arguments[0].url) || arguments[0] || ''); } catch (e) {}
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js|$|\?)/.test(url)) {
        p.then(function () { document.dispatchEvent(new CustomEvent('mda:cart:updated')); }).catch(function () {});
      }
      return p;
    };
  }

  // --- GLOBAL: AJAX add-to-cart for [data-mda-cart-add] (stays on page) ---
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mda-cart-add]');
    if (!btn) return;
    e.preventDefault();
    var id = parseInt(btn.getAttribute('data-mda-cart-add'), 10);
    if (!id || btn.getAttribute('data-busy')) return;
    btn.setAttribute('data-busy', '1');
    btn.classList.add('is-loading');
    var labelEl = btn.querySelector('.mda-button__label');
    var orig = labelEl ? labelEl.textContent : '';
    var added = btn.getAttribute('data-added-label');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quantity: 1 }) })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('data-busy');
        if (labelEl && added) {
          labelEl.textContent = added;
          btn.classList.add('is-added');
          setTimeout(function () { labelEl.textContent = orig; btn.classList.remove('is-added'); }, 1800);
        }
        if (window.__mdaSyncGift) { window.__mdaSyncGift(broadcast); } else { broadcast(); }
      })
      .catch(function () { btn.classList.remove('is-loading'); btn.removeAttribute('data-busy'); });
  });

  // --- Progress bar (campaign-gated) ---
  var el = document.querySelector('[data-mda-spprogress]');
  if (!el) return;
  var curTpl = (el.getAttribute('data-current-template') || '').trim();
  var suppress = (el.getAttribute('data-suppress-templates') || '').split(',').map(function (s) { return s.trim(); });
  if (curTpl && suppress.indexOf(curTpl) !== -1) return;
  var key = el.getAttribute('data-campaign-key');
  function flagged() { try { return !!sessionStorage.getItem(key); } catch (e) { return false; } }
  function dismissed() { try { return !!sessionStorage.getItem(key + '_dismissed'); } catch (e) { return false; } }
  if (!flagged() || dismissed()) return;

  var threshold = Math.round(parseFloat(el.getAttribute('data-threshold')) * 100) || 0;
  var giftVariant = parseInt(el.getAttribute('data-gift-variant'), 10) || 0;
  var reward = el.getAttribute('data-reward') || '';
  var msgAway = el.getAttribute('data-msg-away') || '';
  var msgUnlocked = el.getAttribute('data-msg-unlocked') || '';
  var msgAdded = el.getAttribute('data-msg-added') || '';
  var textEl = el.querySelector('[data-mda-spprogress-text]');
  var fillEl = el.querySelector('[data-mda-spprogress-fill]');
  var claimBtn = el.querySelector('[data-mda-spprogress-claim]');
  var busy = false;

  function money(c) { return '$' + (c / 100).toFixed(2); }
  function qualifyingSubtotal(cart) {
    var sum = 0;
    cart.items.forEach(function (i) { if (i.variant_id !== giftVariant) sum += i.final_line_price; });
    return sum;
  }
  function giftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) { if (cart.items[i].variant_id === giftVariant) return cart.items[i]; }
    return null;
  }
  var giftAttempts = 0;
  var MAX_GIFT_ATTEMPTS = 2;

  function notifyCartApps() {
    // UpCart caches its drawer contents and only re-fetches on close/reopen, so
    // call its refresh API directly. Generic events are kept for other apps.
    if (typeof window.upcartRefreshCart === 'function') {
      try { window.upcartRefreshCart(); } catch (e) {}
    }
    ['cart:refresh', 'cart:updated', 'cart:build'].forEach(function (n) {
      try { document.dispatchEvent(new CustomEvent(n, { bubbles: true })); } catch (e) {}
      try { window.dispatchEvent(new CustomEvent(n)); } catch (e) {}
    });
  }

  var discountCode = (el.getAttribute('data-discount-code') || '').trim();
  var reseeded = false;

  function giftIsFree(cart) {
    var gl = giftLine(cart);
    return !!gl && gl.final_line_price === 0;
  }

  function dropGift(done) {
    cartThen(function (cart) {
      var gl = giftLine(cart);
      if (!gl) { if (done) done(); return; }
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: gl.key, quantity: 0 }) })
        .then(function () { notifyCartApps(); broadcast(); if (done) done(); })
        .catch(function () { if (done) done(); });
    });
  }

  // Never leave an undiscounted gift in the cart: if the discount session was
  // lost the gift would sit there at full price. Re-seed the code once, and if
  // it still is not free, remove it and fall back to the manual claim button.
  function verifyGiftFree(cb) {
    cartThen(function (cart) {
      if (giftIsFree(cart)) { busy = false; notifyCartApps(); broadcast(); refresh(); if (cb) cb(); return; }
      if (!giftLine(cart)) { busy = false; refresh(); if (cb) cb(); return; }
      if (!reseeded && discountCode) {
        reseeded = true;
        fetch('/discount/' + encodeURIComponent(discountCode), { credentials: 'same-origin' })
          .then(function () { return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _mda_gift: 'luxfree' } }) }); })
          .then(function () { verifyGiftFree(cb); })
          .catch(function () { verifyGiftFree(cb); });
        return;
      }
      giftAttempts = MAX_GIFT_ATTEMPTS;
      dropGift(function () { busy = false; refresh(); if (cb) cb(); });
    });
  }

  function addGift(cb) {
    if (busy || !giftVariant) { if (cb) cb(); return; }
    busy = true;
    giftAttempts++;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: giftVariant, quantity: 1 }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { verifyGiftFree(cb); })
      .catch(function () { busy = false; refresh(); if (cb) cb(); });
  }

  window.__mdaSyncGift = function (cb) {
    if (!giftVariant) { if (cb) cb(); return; }
    cartThen(function (cart) {
      if (qualifyingSubtotal(cart) >= threshold && !giftLine(cart) && giftAttempts < MAX_GIFT_ATTEMPTS) {
        addGift(cb);
      } else if (cb) { cb(); }
    });
  };
  function removeGift(lineKey) {
    if (busy) return;
    busy = true;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: lineKey, quantity: 0 }) })
      .then(function () { busy = false; notifyCartApps(); broadcast(); refresh(); }).catch(function () { busy = false; });
  }
  function apply(cart) {
    var qs = qualifyingSubtotal(cart);
    var gl = giftLine(cart);
    var remaining = threshold - qs;
    var pct = threshold > 0 ? Math.min(100, Math.round((qs / threshold) * 100)) : 0;
    if (fillEl) fillEl.style.width = pct + '%';
    if (remaining > 0) {
      el.classList.remove('is-unlocked');
      if (textEl) textEl.textContent = msgAway.replace('{amount}', money(remaining)).replace('{reward}', reward);
      if (claimBtn) claimBtn.hidden = true;
      if (gl) { giftAttempts = 0; removeGift(gl.key); }
    } else {
      el.classList.add('is-unlocked');
      if (gl) {
        if (gl.final_line_price !== 0 && !busy) {
          busy = true;
          verifyGiftFree();
          return;
        }
        if (textEl) textEl.textContent = msgAdded.replace('{reward}', reward);
        if (claimBtn) claimBtn.hidden = true;
      } else if (giftAttempts < MAX_GIFT_ATTEMPTS && !busy) {
        if (textEl) textEl.textContent = msgUnlocked.replace('{reward}', reward);
        if (claimBtn) claimBtn.hidden = true;
        addGift();
      } else {
        if (textEl) textEl.textContent = msgUnlocked.replace('{reward}', reward);
        if (claimBtn) claimBtn.hidden = false;
      }
    }
  }
  function refresh() { cartThen(function (c) { apply(c); el.hidden = false; }); }

  if (claimBtn) claimBtn.addEventListener('click', addGift);
  document.addEventListener('mda:cart:updated', function () { if (!busy) refresh(); });
  refresh();
  var poll = setInterval(function () { if (document.visibilityState === 'visible' && !busy) refresh(); }, 5000);
  window.addEventListener('focus', refresh);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') refresh(); });

  var dismiss = el.querySelector('[data-mda-spprogress-dismiss]');
  if (dismiss) {
    dismiss.addEventListener('click', function () {
      el.hidden = true;
      clearInterval(poll);
      try { sessionStorage.setItem(key + '_dismissed', '1'); } catch (e) {}
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
